import * as React from 'react';
import { useTranslation } from 'react-i18next';
export var SelfServiceResignationBanner = function () {
    var t = useTranslation().t;
    return (React.createElement("div", { "data-testid": "self-resignation-footer-bar", className: "self-resignation-footer-bar" },
        React.createElement("div", { className: "container button-footer" },
            React.createElement("div", { className: "text-center instructions" },
                t('shift_management_features_ssr_bar_button_instructions'),
                React.createElement("span", { id: "ssr-link-label", hidden: true }, t('shift_management_features_ssr_bar_button_label')),
                React.createElement("a", { href: "/resignation?source=shifts", className: "action btn-link learn_more_btn", "data-omniture-link": "SSR:GSFDashboard:learnMore:reroute", "aria-labelledby": "ssr-link-label" }, t('shift_management_features_ssr_bar_button_title'))))));
};
